module.exports = __webpack_public_path__ + "static/media/Niveau_elN8_2_1018416.c28ef7ee.png";